export class AccountCenterSummaryRequest {
    period: number;
    year: number;
    constructor(period:number, year:number) {
        this.period = period;
        this.year = year;
    }
}